export function DiscoverySkeleton() {
  return (
    <>
      {/* Featured card */}
      <div className="h-[220px] w-full animate-pulse rounded-[24px] bg-app-grey-200" />

      {/* Secondary section */}
      <div className="flex flex-col gap-[16px]">
        <div className="h-4 w-24 animate-pulse rounded bg-app-grey-200 lg:mx-auto" />
        <div className="-mx-[24px] flex gap-[12px] overflow-hidden px-[24px] lg:mx-0 lg:gap-2 lg:px-0">
          {Array.from({ length: 3 }, (_, i) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: skeleton
              key={i}
              className="h-[238px] w-[calc(50%-6px)] flex-shrink-0 animate-pulse rounded-[24px] bg-app-grey-200 lg:h-[14.875rem] lg:w-42 lg:flex-none"
            />
          ))}
        </div>
      </div>

      {/* Banner card */}
      <div className="h-[108px] w-full animate-pulse rounded-[24px] bg-app-grey-200 lg:h-[6.75rem]" />
    </>
  )
}
